import withAuth from '../../../../contexts/AuthContext/withAuth'
import FormUpdateUser from './FormUpdateUser'

export default withAuth(FormUpdateUser)
